"use strict";
function initBrandstofSection(section) {
    const litersInput = section.querySelector(".brandstof-section__lites-input");
    const priceInput = section.querySelector(".brandstof-section__price-input");
    const mainPrice = section.querySelector(".brandstof-yearly-cost__value .value");
    const savings = section.querySelectorAll(".brandstof-saving:not(.brandstof-saving--total)");
    const savingsTotal = section.querySelector(".brandstof-saving--total");
    const header = section.querySelector(".brandstof-section__header");
    if (!litersInput ||
        !priceInput ||
        !mainPrice ||
        !savings ||
        !savingsTotal ||
        !header)
        return;
    header.addEventListener("click", () => {
        section.classList.toggle("active");
    });
    function update() {
        const l = parseFloat(litersInput.value) || 0;
        const p = parseFloat(priceInput.value) || 0;
        const co2 = parseFloat(section.dataset.co2) || 0;
        const fullPrice = l * p;
        const fullEmission = l * co2;
        mainPrice.innerText = `${Math.round(fullPrice)}`;
        let totalCostSavings = 0;
        let totalCo2Savings = 0;
        savings.forEach((saving) => {
            const costField = saving.querySelector(".brandstof-saving__cost-reduction .value");
            const co2Field = saving.querySelector(".brandstof-saving__co2-reduction .value");
            const reduction = parseFloat(saving.dataset.reduction);
            totalCostSavings += fullPrice * reduction;
            totalCo2Savings += fullEmission * reduction;
            costField.innerText = `${Math.round(fullPrice * reduction)}`;
            co2Field.innerText = `${Math.round(fullEmission * reduction)}`;
        });
        const totalCostField = savingsTotal.querySelector(".brandstof-saving__cost-reduction .value");
        const totalCo2Field = savingsTotal.querySelector(".brandstof-saving__co2-reduction .value");
        totalCostField.innerText = `${Math.round(totalCostSavings)}`;
        totalCo2Field.innerText = `${Math.round(totalCo2Savings)}`;
    }
    update();
    litersInput.addEventListener("input", update);
    priceInput.addEventListener("input", update);
}
const sections = document.querySelectorAll(".brandstof-section");
sections.forEach(initBrandstofSection);
